import axios from "axios";
import $ from "jquery";
import store from "../store";
import { logoutAction } from "../store/slices/auth/logoutAction";

const baseURL = process.env.NODE_ENV === "production" ? "" : "http://localhost:8888";

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = store.getState().auth.accessToken;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if ((error.response && error.response.status === 403) || error.code === "ECONNREFUSED") {
      $(".ui-dialog-content").dialog("close");
      store.dispatch(logoutAction());
    }
    return Promise.reject(error);
  }
);
export default instance;
